var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _circle7, _path5, _ellipse, _ellipse2, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFibo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 132,
    viewBox: "0 0 233 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 26.4018,
    width: 229.026,
    height: 33.0102,
    rx: 16.5051,
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210.562,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.619,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.676,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9136,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.9702,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0264,
    cy: 42.8183,
    r: 4.96142,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.86 14.9373C164.062 10.2527 175.783 30.0539 148.342 30.6567Z",
    fill: "#F8A63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.86 14.9373C164.062 10.2527 175.783 30.0539 148.342 30.6567",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8993 44.2068C52.8993 44.2068 36.5919 53.2253 40.6094 63.7065C42.4774 68.5938 55.8544 63.9437 55.8544 63.9437",
    fill: "#F8A63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8993 44.2068C52.8993 44.2068 36.5919 53.2253 40.6094 63.7065C42.4774 68.5938 55.8544 63.9437 55.8544 63.9437",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.652,
    cy: 61.6852,
    r: 59.6852,
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6123 66.0641L116.819 58.2316",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.8333,
    cy: 56.4529,
    rx: 4.23994,
    ry: 6.72559,
    transform: "rotate(-20.94 88.8333 56.4529)",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.533,
    cy: 45.0851,
    rx: 4.23994,
    ry: 6.72559,
    transform: "rotate(-20.94 118.533 45.0851)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5493 63.6674C86.6253 63.6674 92.7283 70.0668 92.4911 76.5156",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4258,
    y: 98.1348,
    width: 187.6,
    height: 33.8651,
    fill: "#FDF1DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4258 98.1349H198.021",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.262 74.5832C165.262 74.5832 129.549 93.0452 145.569 101.471C157.642 107.821 173.089 100.354 177.117 98.5057C184.178 95.3085 183.368 73.1847 165.262 74.5832Z",
    fill: "#F8A63F",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5601 83.3399C73.313 87.7429 70.5556 99.1779 68.91 102.059C63.1431 112.169 37.9802 109.807 43.3765 93.2232C47.3594 81.0371 59.1898 66.4147 70.1849 68.7521C79.1244 70.6497 96.094 81.5757 72.5421 90.614",
    fill: "#F8A63F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5601 83.3399C73.313 87.7429 70.5556 99.1779 68.91 102.059C63.1431 112.169 37.9802 109.807 43.3765 93.2232C47.3594 81.0371 59.1898 66.4147 70.1849 68.7521C79.1244 70.6497 96.094 81.5757 72.5421 90.614",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M113.785 119.127L72.4878 102.854V96.9685L113.785 112.634V119.127V119.127Z",
    fill: "#999999",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.785 112.634V119.127L161.339 114.704V108.68L113.785 112.634V112.634Z",
    fill: "#999999",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.339 108.68L113.785 112.634L72.4878 96.9686L108.725 93.9591L161.339 108.68V108.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.743 57.4058C206.218 61.458 198.237 91.3253 129.924 92.1852C129.924 92.1852 181.954 85.7956 192.619 57.4058",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M208.743 57.4058C206.218 61.458 198.237 91.3253 129.924 92.1852C129.924 92.1852 181.954 85.7956 192.619 57.4058",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFibo);
export default __webpack_public_path__ + "static/media/top-fibo.21c7e4139ef2c89063f144dfa0bb0c88.svg";
export { ForwardRef as ReactComponent };